import { render, staticRenderFns } from "./xtMessageWeb.vue?vue&type=template&id=182b8fe8&scoped=true&"
import script from "./xtMessageWeb.vue?vue&type=script&lang=js&"
export * from "./xtMessageWeb.vue?vue&type=script&lang=js&"
import style0 from "./xtMessageWeb.vue?vue&type=style&index=0&id=182b8fe8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182b8fe8",
  null
  
)

export default component.exports